// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"3fd31465","824":"3fd31465"}[chunkId] + ".chunk.css";
};